import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useNavigate } from 'react-router-dom';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import AgendaCitaModal from '@/components/pages/Home/modals/AgendaCitaModal';
import ErrorPagoModal from '@/components/pages/Home/modals/ErrorPagoModal';
import AgendaExitosaModal from '@/components/pages/Home/modals/AgendaExitosaModal';
import AgendaExitosaModal2 from '@/components/pages/Home/modals/AgendaExitosaModal2';
import AgendaCitaAgregarFamiliar from '@/components/pages/Home/modals/AgendaCitaAgregarFamiliar';
import AgendaTipoCitaModal from '@/components/pages/Home/modals/AgendaTipoCitaModal';
import AgendaCitaConfirmacionModal from '@/components/pages/Home/modals/AgendaCitaConfirmacionModal';
import AgendaCitaMedicoModal from '@/components/pages/Home/modals/AgendaCitaMedicoModal';
import AgendaCitaFechaModal from '@/components/pages/Home/modals/AgendaCitaFechaModal';
import AgendaCitaFacturacionModal from '@/components/pages/Home/modals/AgendaCitaFacturacionModal';
import Label from '@/components/form/Label/Label';

const HomeView = (props) => {
  const {
    setFilteredDoctorList,
    filteredDoctorList,
    listaEspecialidades,
    changueEspFilter,
    selectedSpeciality,
    selectedDoctor,
    changeDoctorFilter,
    medicalHistory,
    isLoadingHistory,
    historyError,
    selectedSchedule,
    selectSchedule,
    appointmentType,
    priceBase,
    setExternalPrice,
    changeAppointmentType,
    validationSchemaFacturacion,
    saveMedicalHistory,
    doctorServices,
    selectedService,
    selectService,
    patientInformation,
    setPatientInformation,
    patientsxUser,
    loadingSaveHistory,
    isLoadingPersonal,
    getPatientsForDoctor,
    isLoadingPatientsxUser,
    isLoadingSpeciality,
    isLoadingDoctor,
    setIsLoadingDoctor,
    returnMedicalHistoryForPay,
  } = props;

  const navigate = useNavigate();

  const [openAgendaModal, setOpenAgendaModal] = useState(false);
  const [openErrorPagoModal, setOpenErrorPagoModal] = useState(false);
  const [openAgendaExitosaModal, setOpenAgendaExitosaModal] = useState(false);
  const [openAgendaExitosaModal2, setOpenAgendaExitosaModal2] = useState(false);
  const [openAgendaCitaAgregarFamiliar, setOpenAgendaCitaAgregarFamiliar] = useState(false);
  const [openAgendaTipoCitaModal, setOpenAgendaTipoCitaModal] = useState(false);
  const [openAgendaCitaConfirmacionModal, setOpenAgendaCitaConfirmacionModal] = useState(false);
  const [openAgendaCitaMedicoModal, setOpenAgendaCitaMedicoModal] = useState(false);
  const [openAgendaCitaFechaModal, setOpenAgendaCitaFechaModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [openAgendaCitaFacturacionModal, setOpenAgendaCitaFacturacionModal] = useState(false);
  const [jsonToPay, setJsonToPay] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openAgendaUnaCita = () => {
    getPatientsForDoctor(2);
    setOpenAgendaModal(true);
  };

  const goToMyReports = () => {
    navigate('/reporte');
  };

  const goToDatingHistory = () => {
    navigate('/historia-cita');
  };

  const handleContactClick = () => {
    const mailtoLink = 'mailto:informes@drq.com.pe';
    const gmailLink = 'https://mail.google.com/mail/?view=cm&to=informes@drq.com.pe';

    window.location.href = mailtoLink;

    setTimeout(() => {
      window.open(gmailLink, '_blank', 'noopener,noreferrer');
    }, 500);
  };

  const paciente = JSON.parse(localStorage.getItem('user')) || {};
  const authData = JSON.parse(localStorage.getItem('auth_data')) || {};
  const patientData = authData?.paciente;
  const nombrePaciente = paciente.name
    ? `${paciente.name} ${paciente.paterno || ''} ${paciente.materno || ''}`
    : 'Paciente prueba';

  const mainCards = [
    {
      icon: 'fas fa-calendar-alt',
      text: 'Agenda una cita',
      action: () => openAgendaUnaCita(),
    },
    {
      icon: 'fas fa-notes-medical',
      text: 'Mis citas',
      action: () => goToDatingHistory(),
    },
    {
      icon: 'fas fa-x-ray',
      text: 'Resultados',
      action: () => goToMyReports(),
    },
  ];

  return (
    <>
      <AgendaCitaModal
        open={openAgendaModal}
        onClose={() => setOpenAgendaModal(false)}
        onSelectDaniel={() => {
          setOpenAgendaModal(false);
          setOpenAgendaTipoCitaModal(true);
        }}
        onAgreeButton={() => {
          setOpenAgendaModal(false);
          setOpenAgendaCitaAgregarFamiliar(true);
        }}
        doctorServices={doctorServices}
        patientsxUser={patientsxUser}
        patientInformation={patientInformation}
        setPatientInformation={setPatientInformation}
        patientDataFromLocalStorage={patientData}
        isLoadingPatientsxUser={isLoadingPatientsxUser}
      />
      <ErrorPagoModal open={openErrorPagoModal} onClose={() => setOpenErrorPagoModal(false)} />

      <AgendaCitaAgregarFamiliar
        open={openAgendaCitaAgregarFamiliar}
        onClose={() => setOpenAgendaCitaAgregarFamiliar(false)}
        onError={() => {
          setOpenAgendaCitaAgregarFamiliar(false);
          setOpenErrorPagoModal(true);
        }}
        appointmentType={appointmentType}
        priceBase={priceBase}
        changeDoctorFilter={changeDoctorFilter}
        selectedDoctor={selectedDoctor}
      />
      <AgendaExitosaModal
        open={openAgendaExitosaModal}
        onClose={() => setOpenAgendaExitosaModal(false)}
        onError={() => {
          setOpenAgendaExitosaModal(false);
          setOpenErrorPagoModal(true);
        }}
        appointmentType={appointmentType}
        priceBase={priceBase}
        loadingSaveHistory={loadingSaveHistory}
        jsonToPay={jsonToPay}
      />
      <AgendaExitosaModal2
        open={openAgendaExitosaModal2}
        onClose={() => setOpenAgendaExitosaModal2(false)}
        onError={() => {
          setOpenAgendaExitosaModal2(false);
          setOpenErrorPagoModal(true);
        }}
        appointmentType={appointmentType}
        priceBase={priceBase}
        loadingSaveHistory={loadingSaveHistory}
      />
      <AgendaTipoCitaModal
        open={openAgendaTipoCitaModal}
        onClose={() => setOpenAgendaTipoCitaModal(false)}
        goStep2={() => {
          setOpenAgendaTipoCitaModal(false);
          setOpenAgendaCitaMedicoModal(true);
          setCurrentStep(2);
        }}
        goStep3={() => {
          setOpenAgendaTipoCitaModal(false);
          setOpenAgendaCitaFechaModal(true);
          setCurrentStep(3);
        }}
        goStep4={() => {
          setOpenAgendaTipoCitaModal(false);
          setOpenAgendaCitaConfirmacionModal(true);
          setCurrentStep(4);
        }}
        setFilteredDoctorList={setFilteredDoctorList}
        listaEspecialidades={listaEspecialidades}
        changueEspFilter={changueEspFilter}
        selectedSpeciality={selectedSpeciality}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
      <AgendaCitaConfirmacionModal
        open={openAgendaCitaConfirmacionModal}
        patientInformation={patientInformation}
        onClose={() => setOpenAgendaCitaConfirmacionModal(false)}
        goStep1={() => {
          setOpenAgendaCitaConfirmacionModal(false);
          setOpenAgendaTipoCitaModal(true);
          setCurrentStep(1);
        }}
        goStep2={() => {
          setOpenAgendaCitaConfirmacionModal(false);
          setOpenAgendaCitaMedicoModal(true);
          setCurrentStep(2);
        }}
        goStep3={() => {
          setOpenAgendaCitaConfirmacionModal(false);
          setOpenAgendaCitaFechaModal(true);
          setCurrentStep(3);
        }}
        onConfirm={() => {
          setOpenAgendaCitaConfirmacionModal(false);
          setOpenAgendaCitaFacturacionModal(true);
        }}
        data={selectedSchedule}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        doctorServices={doctorServices}
        selectedService={selectedService}
        selectService={selectService}
        appointmentType={appointmentType}
        priceBase={priceBase}
        setExternalPrice={setExternalPrice}
        changeAppointmentType={changeAppointmentType}
        isLoadingPersonal={isLoadingPersonal}
      />
      <AgendaCitaMedicoModal
        open={openAgendaCitaMedicoModal}
        filteredDoctorList={filteredDoctorList}
        onClose={() => setOpenAgendaCitaMedicoModal(false)}
        goStep1={() => {
          setOpenAgendaCitaMedicoModal(false);
          setOpenAgendaTipoCitaModal(true);
          setCurrentStep(1);
        }}
        goStep3={() => {
          setOpenAgendaCitaMedicoModal(false);
          setOpenAgendaCitaFechaModal(true);
          setCurrentStep(3);
        }}
        goStep4={() => {
          setOpenAgendaCitaMedicoModal(false);
          setOpenAgendaCitaConfirmacionModal(true);
          setCurrentStep(4);
        }}
        listaEspecialidades={listaEspecialidades}
        changueEspFilter={changueEspFilter}
        selectedSpeciality={selectedSpeciality}
        selectedDoctor={selectedDoctor}
        changeDoctorFilter={changeDoctorFilter}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        isLoadingDoctor={isLoadingDoctor}
        setIsLoadingDoctor={setIsLoadingDoctor}
      />

      <AgendaCitaFechaModal
        open={openAgendaCitaFechaModal}
        onClose={() => setOpenAgendaCitaFechaModal(false)}
        goStep1={() => {
          setOpenAgendaCitaFechaModal(false);
          setOpenAgendaTipoCitaModal(true);
          setCurrentStep(1);
        }}
        goStep2={() => {
          setOpenAgendaCitaFechaModal(false);
          setOpenAgendaCitaMedicoModal(true);
          setCurrentStep(2);
        }}
        goStep4={() => {
          setOpenAgendaCitaFechaModal(false);
          setOpenAgendaCitaConfirmacionModal(true);
          setCurrentStep(4);
        }}
        filteredDoctorList={filteredDoctorList}
        listaEspecialidades={listaEspecialidades}
        changueEspFilter={changueEspFilter}
        selectedSpeciality={selectedSpeciality}
        selectedDoctor={selectedDoctor}
        changeDoctorFilter={changeDoctorFilter}
        medicalHistory={medicalHistory}
        isLoadingHistory={isLoadingHistory}
        historyError={historyError}
        selectedSchedule={selectedSchedule}
        selectSchedule={selectSchedule}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        isLoadingSpeciality={isLoadingSpeciality}
        isLoadingDoctor={isLoadingDoctor}
        setIsLoadingDoctor={setIsLoadingDoctor}
      />

      <AgendaCitaFacturacionModal
        open={openAgendaCitaFacturacionModal}
        onClose={() => {
          setOpenAgendaCitaFacturacionModal(false);
          setOpenAgendaCitaConfirmacionModal(true);
          setCurrentStep(4);
        }}
        appointmentType={appointmentType}
        priceBase={priceBase}
        validationSchemaFacturacion={validationSchemaFacturacion}
        saveMedicalHistory={saveMedicalHistory}
        returnMedicalHistoryForPay={returnMedicalHistoryForPay}
        setJsonToPay={setJsonToPay}
        selectedDoctor={selectedDoctor}
        selectedSchedule={selectedSchedule}
        selectedSpeciality={selectedSpeciality}
        patientData={patientData}
        onConfirm={() => {
          setOpenAgendaCitaFacturacionModal(false);
          setOpenAgendaExitosaModal(true);
        }}
        onConfirm2={() => {
          setOpenAgendaCitaFacturacionModal(false);
          setOpenAgendaExitosaModal2(true);
        }}
      />

      <div
        className="App bgGradientBlueReverse"
        style={{
          minHeight: '100vh',
          flexDirection: 'column',
          backgroundSize: '500px',
          backgroundRepeat: 'repeat',
          backgroundPosition: 'top left',
        }}
      >
        <HelmetComponent title={''} description={''} />

        <FlexContainer
          className={'m-flex-column margt90 m-margt30 width100 gap-40 m-gap-10 m-margb30'}
          style={{
            alignItems: 'flex-start',
          }}
        >
          <FlexContainer className={'padlr50 flex-column margt30'}>
            <FlexContainer className={'flex-column'} style={{ minWidth: '180px' }}>
              <Label className={'text-14 fontWhite'}>
                <strong>Hola</strong>
              </Label>
              <Label className={'text-18 fontBold fontWhite'}>
                <strong>{nombrePaciente}</strong>,
              </Label>
              <Label className={'text-14 fontWhite'}>Bienvenido</Label>
              <FlexContainer
                className="flex-row align-center gap-10 margt10 pointer"
                onClick={handleContactClick}
                style={{
                  padding: '12px 0px',
                  borderRadius: '8px',
                }}
              >
                <i
                  className="fas fa-envelope"
                  style={{
                    fontSize: '30px',
                    color: '#ffffff',
                  }}
                />
                <Label className="text-16 fontWhite fontSemiBold padt4">Contáctanos</Label>
              </FlexContainer>

              <a
                href="https://www.google.com/maps/place/Centro+Dr.+Q+-+Tu+salud,+nuestra+pasi%C3%B3n/@-12.1106539,-77.0344226,17z/data=!3m1!4b1!4m6!3m5!1s0x9105c7ec7e400001:0xc9c5e1d53dbb54b4!8m2!3d-12.1106592!4d-77.0298092!16s%2Fg%2F11flw1jklj?entry=ttu"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <FlexContainer
                  className={'flex-row align-center gap-10 pointer'}
                  style={{
                    padding: '12px 0px',
                    borderRadius: '8px',
                  }}
                >
                  <i
                    className={'fas fa-map-marker-alt'}
                    style={{
                      fontSize: '30px',
                      color: '#ffffff',
                    }}
                  />
                  <Label className={'text-16 fontWhite fontSemiBold padt4'}>Ubícanos</Label>
                </FlexContainer>
              </a>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer
            className={'flex-row gap-20 margt30 align-self-center m-padlr40'}
            style={{
              flex: 1,
              justifyContent: 'flex-start',
              flexWrap: 'wrap',
            }}
          >
            {mainCards.map((item, index) => (
              <FlexContainer
                key={index}
                onClick={item.action}
                className={
                  'flex-column align-center justify-center pointer borderRad16 transition300 bgGray100 format40 m-format100 '
                }
                style={{
                  height: '170px',
                  boxShadow: '0 3px 12px rgba(0,0,0,0.1)',
                  textAlign: 'center',
                  border: item.active ? '2px solid #023B7A' : '2px solid transparent',
                  backgroundColor: item.active ? '#023B7A' : '#f8f9fa',
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#8bb0eb';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(2, 59, 122, 0.3)';
                  e.currentTarget.style.transform = 'translateY(-5px)';

                  const icon = e.currentTarget.querySelector('.card-icon');
                  if (icon) icon.style.color = '#ffffff';

                  const label = e.currentTarget.querySelector('.card-label');
                  if (label) {
                    label.style.color = '#ffffff';
                    label.classList.add('fontWhite');
                    label.classList.remove('fontPrimaryBlue');
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = item.active ? '#023B7A' : '#f8f9fa';
                  e.currentTarget.style.boxShadow = '0 3px 12px rgba(0,0,0,0.1)';
                  e.currentTarget.style.transform = 'translateY(0)';

                  const icon = e.currentTarget.querySelector('.card-icon');
                  if (icon) icon.style.color = item.active ? '#ffffff' : '#023B7A';

                  const label = e.currentTarget.querySelector('.card-label');
                  if (label) {
                    if (item.active) {
                      label.style.color = '#ffffff';
                      label.classList.add('fontWhite');
                      label.classList.remove('fontPrimaryBlue');
                    } else {
                      label.style.color = '#023B7A';
                      label.classList.remove('fontWhite');
                      label.classList.add('fontPrimaryBlue');
                    }
                  }
                }}
              >
                <i
                  className={`${item.icon} card-icon`}
                  style={{
                    fontSize: '50px',
                    marginBottom: '10px',
                    transition: 'color 0.3s ease',
                    color: item.active ? '#ffffff' : '#023B7A',
                  }}
                />

                <Label
                  className={`text-20 fontSemiBold card-label transition300 ${
                    item.active ? 'fontWhite' : 'fontPrimaryBlue'
                  }`}
                  style={{
                    transition: 'color 0.3s ease',
                  }}
                >
                  {item.text}
                </Label>
              </FlexContainer>
            ))}
          </FlexContainer>
        </FlexContainer>
      </div>
    </>
  );
};

export default HomeView;
